import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import Login from './Login';
import jwt_decode, { jwtDecode } from "jwt-decode";
import NurseScheduleCard from './NurseScheduleCard';
import { BrowserRouter as Router } from 'react-router-dom';
import ProfilePage from './ProfilePage';
import AppRoutes from './AppRoutes';
import { BASE_API } from './constants';

interface Patient {
  id: string;
  demographics: {
    fullName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    age?: string;
    pictureUrl?: string;
    nickname?: string;
  };
  patientLastActiveTime?: string;
}

interface NurseDashboardCategory {
  category: {
    id: string;
    name: string;
    description: string;
    createdAt: string | null;
  };
  patients: Patient[];
}

function getTokenExpiry(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  const expiry = getTokenExpiry(token);
  return expiry ? Date.now() < expiry : false;
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;

